import { api } from "./api";

/**
 * Poll a background task until it completes or errors.
 * Kicks off with POST payload, then GETs /api/tasks/{task_id} every `intervalMs`.
 *
 * @param {string} startUrl POST endpoint (e.g. /api/brand/generate)
 * @param {object|null} body request body (or null for empty)
 * @param {object} opts { intervalMs=2000, maxMs=180000, onTick(taskDoc) }
 * @returns Promise<taskDoc>  resolves when status==='done', rejects on 'error' / timeout
 */
export async function runTask(startUrl, body = null, opts = {}) {
  const { intervalMs = 2000, maxMs = 180000, onTick } = opts;
  const { data: kick } = await api.post(startUrl, body || {});
  const taskId = kick.task_id;
  if (!taskId) throw new Error("No task_id returned by " + startUrl);

  const start = Date.now();
  while (true) {
    if (Date.now() - start > maxMs) throw new Error("Task timed out");
    const { data } = await api.get(`/api/tasks/${taskId}`);
    if (onTick) onTick(data);
    if (data.status === "done") return data;
    if (data.status === "error") throw new Error(data.error || "Task failed");
    await new Promise((r) => setTimeout(r, intervalMs));
  }
}
